<template> 
    <ul class="navbar-nav bg-gradient-primary sidebar accordion" id="accordionSidebar">
        <a class="sidebar-brand d-flex align-items-center justify-content-center" href="javascript:;">
            <img src="../../assets/images/min-logo.svg" alt="" class="res">
            <img src="../../assets/images/logo.svg" alt="" class="dskp">
        </a>
        <li class="nav-item aa">
            <router-link to="/" class="nav-link collapsed" exact>
                <span>Dashboard</span> 
            </router-link>
        </li>
        <li class="nav-item cc">
            <router-link 
                to="/tickets" 
                class="nav-link collapsed" 
                :class="{ 'router-link-active': $route.path.startsWith('/tickets') }">
                <span>Tickets</span>
            </router-link>             
        </li>
        <li class="nav-item dd">
            <router-link to="/customers" class="nav-link collapsed" exact>
                <span>Customers</span> 
            </router-link>             
        </li>
        <li class="nav-item bb">
            <router-link to="/team-member" class="nav-link collapsed" exact>
                <span>Team Member</span> 
            </router-link>             
        </li>
        <li class="nav-item ee d-none">
            <router-link to="/priority" class="nav-link collapsed" exact>
                <span>Priority</span> 
            </router-link>             
        </li>      
        <li class="nav-item ff" data-bs-toggle="modal" data-bs-target="#logoutModals">
            <a class="nav-link collapsed" href="javascript:;" exact>
                <span >Logout</span> 
            </a>
        </li>
    </ul>
</template>
<script>
export default {
    name: 'SideMenuPage',
}  
</script>